import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const WhatsAppButton = () => {
	const [isVisible, setIsVisible] = useState(false);
	const [showTooltip, setShowTooltip] = useState(false);
	const [hasShownTooltip, setHasShownTooltip] = useState(false);

	const phoneNumber = "919895297783";
	const message = encodeURIComponent("Hi, I'm interested in learning Kalaripayattu at VPS Kalari");
	const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

	useEffect(() => {
		// Show button after a short delay for better UX
		const showTimer = setTimeout(() => {
			setIsVisible(true);
		}, 2000);

		return () => clearTimeout(showTimer);
	}, []);

	useEffect(() => {
		// Show tooltip once after button appears
		if (isVisible && !hasShownTooltip) {
			const tooltipTimer = setTimeout(() => {
				setShowTooltip(true);
				setHasShownTooltip(true);
				// Hide tooltip after 4 seconds
				setTimeout(() => setShowTooltip(false), 4000);
			}, 1000);

			return () => clearTimeout(tooltipTimer);
		}
	}, [isVisible, hasShownTooltip]);

	return (
		<AnimatePresence>
			{isVisible && (
				<motion.div
					className="fixed bottom-6 right-6 z-50 flex items-center gap-3"
					initial={{ scale: 0, opacity: 0 }}
					animate={{ scale: 1, opacity: 1 }}
					exit={{ scale: 0, opacity: 0 }}
					transition={{ type: "spring", stiffness: 260, damping: 20 }}>
					{/* Tooltip */}
					<AnimatePresence>
						{showTooltip && (
							<motion.div
								initial={{ opacity: 0, x: 20 }}
								animate={{ opacity: 1, x: 0 }}
								exit={{ opacity: 0, x: 20 }}
								className="hidden sm:block bg-white text-gray-800 px-4 py-2 rounded-lg shadow-lg text-sm font-medium whitespace-nowrap">
								<span>Chat with us!</span>
								<div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1 w-2 h-2 bg-white rotate-45" />
							</motion.div>
						)}
					</AnimatePresence>

					{/* WhatsApp Button */}
					<motion.a
						href={whatsappUrl}
						target="_blank"
						rel="noopener noreferrer"
						className="relative flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-green-500 rounded-full shadow-lg hover:bg-green-600 transition-colors duration-300 group"
						whileHover={{ scale: 1.1 }}
						whileTap={{ scale: 0.95 }}
						onMouseEnter={() => setShowTooltip(true)}
						onMouseLeave={() => setShowTooltip(false)}
						aria-label="Chat on WhatsApp">
						{/* Pulse Animation */}
						<motion.div
							className="absolute inset-0 rounded-full bg-green-500"
							animate={{
								scale: [1, 1.2, 1.2],
								opacity: [0.7, 0, 0],
							}}
							transition={{
								duration: 2,
								repeat: Infinity,
								ease: "easeOut",
							}}
						/>

						{/* Second Pulse */}
						<motion.div
							className="absolute inset-0 rounded-full bg-green-500"
							animate={{
								scale: [1, 1.4, 1.4],
								opacity: [0.5, 0, 0],
							}}
							transition={{
								duration: 2,
								repeat: Infinity,
								ease: "easeOut",
								delay: 0.3,
							}}
						/>

						{/* WhatsApp Icon */}
						<svg
							className="w-7 h-7 sm:w-8 sm:h-8 text-white relative z-10"
							viewBox="0 0 24 24"
							fill="currentColor">
							<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
						</svg>
					</motion.a>
				</motion.div>
			)}
		</AnimatePresence>
	);
};

export default WhatsAppButton;
